import React from 'react'
import { useParams } from 'react-router-dom'
import NotificationDetailContent from '../../features/notifications/components/NotificationDetailContent'

const NotificationDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>()

  return <NotificationDetailContent notificationId={id} />
}

export default NotificationDetail
